import { Outlet } from 'react-router-dom';

import { AUTH_SUB_PAGES } from 'src/pages/auth/auth.constants';

import Dashboard from 'src/pages/dashboard/dashboard.page';
import NotFound from 'src/pages/not-found/not-found.page';
import Notifications from 'src/pages/notifications/notifications.page';
import Settings from 'src/pages/settings/settings.page';
import {
  SignUp,
  ForgotPassword,
  ResetPassword,
  Validation,
  Verification,
} from 'src/pages/auth/sub-pages';
import Customer from 'src/pages/customers/customers.page';
import Gantt from 'src/pages/gantt/gantt.component';
import Employee from 'src/pages/employee/employee.component';
import Project from 'src/pages/projects/projects.component';
import { WelcomePage } from 'src/pages/auth/sub-pages/welcome';
import CustomerDetails from 'src/pages/customers/sub-pages/customer-details/customer-details.component';
import { EmployeeDetails } from 'src/pages/employee/sub-pages/employee-details';
import { ProjectDetails } from 'src/pages/projects/sub-pages/project-details';
import { PROJECTS_SUB_PAGES } from 'src/pages/projects/sub-pages/create-project/create-project.constants';
import { CreateProject } from 'src/pages/projects/sub-pages/create-project';
import { Changelog } from 'src/pages/projects/sub-pages/changelog';

export const ROUTES = {
  dashboard: '/',
  auth: '/auth',
  customers: '/customers',
  settings: '/settings',
  employee: '/employee',
  gantt: '/gantt',
  project: '/project',
  notifications: '/notifications',
  health: '/health',
  notFound: '*',
};

export const SUB_ROUTES = {
  authVerification: `${ROUTES.auth}/${AUTH_SUB_PAGES.verification}`,
  authValidation: `${ROUTES.auth}/${AUTH_SUB_PAGES.validation}`,
  authForgotPassword: `${ROUTES.auth}/${AUTH_SUB_PAGES.forgotPassword}`,
  authWelcome: `${ROUTES.auth}/${AUTH_SUB_PAGES.welcome}`,
};

export const ROUTES_RELATIONS = [
  {
    path: ROUTES.auth,
    PageComponent: Outlet,
    isProtected: false,
    children: [
      {
        subpath: AUTH_SUB_PAGES.verification,
        SubPageComponent: Verification,
      },
      {
        subpath: AUTH_SUB_PAGES.validation,
        SubPageComponent: Validation,
      },
      {
        subpath: AUTH_SUB_PAGES.forgotPassword,
        SubPageComponent: ForgotPassword,
      },
      {
        subpath: AUTH_SUB_PAGES.resetPassword,
        SubPageComponent: ResetPassword,
      },
      {
        subpath: AUTH_SUB_PAGES.signUp,
        SubPageComponent: SignUp,
      },
      {
        subpath: AUTH_SUB_PAGES.welcome,
        SubPageComponent: WelcomePage,
      },
    ],
  },
  {
    path: ROUTES.dashboard,
    PageComponent: Dashboard,
  },
  {
    path: ROUTES.gantt,
    PageComponent: Gantt,
  },
  {
    path: ROUTES.employee,
    PageComponent: Employee,
  },
  {
    path: `${ROUTES.employee}/:id`,
    PageComponent: EmployeeDetails,
  },
  {
    path: ROUTES.project,
    PageComponent: Project,
  },
  {
    path: `${ROUTES.project}/${PROJECTS_SUB_PAGES.createProject}`,
    PageComponent: CreateProject,
  },
  {
    path: `${ROUTES.project}/:id/${PROJECTS_SUB_PAGES.changelog}`,
    PageComponent: Changelog,
  },
  {
    path: `${ROUTES.project}/:id`,
    PageComponent: ProjectDetails,
  },
  {
    path: ROUTES.customers,
    PageComponent: Customer,
  },
  {
    path: `${ROUTES.customers}/:id`,
    PageComponent: CustomerDetails,
  },
  {
    path: `${ROUTES.customers}/${PROJECTS_SUB_PAGES.createProject}/:id`,
    PageComponent: CreateProject,
  },
  {
    path: ROUTES.settings,
    PageComponent: Settings,
  },
  {
    path: ROUTES.notifications,
    PageComponent: Notifications,
  },
  {
    path: ROUTES.health,
    PageComponent: () => <>The App is Healthy</>,
    isProtected: false,
  },
  {
    path: ROUTES.notFound,
    PageComponent: NotFound,
    isProtected: false,
  },
];
